import { render, staticRenderFns } from "./IdentificationStep.vue?vue&type=template&id=1e033f43"
import script from "./IdentificationStep.vue?vue&type=script&lang=ts"
export * from "./IdentificationStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports